import { useQuery } from "@tanstack/react-query";
import { getActiveHotlist } from "@/api/companies";
import type { HotlistEntry } from "@/types/company";

export const useHotlist = () => {
  const query = useQuery<HotlistEntry[]>({
    queryKey: ["hotlist"],
    queryFn: getActiveHotlist,
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  };
};
